import React, { useRef, useEffect } from "react";
import "./MultiLineConnector.css";

const ResponsiveMultiLineConnector = ({ overWriteFunction, dots = [], connections = [] }) => {
  const containerRef = useRef(null); // Reference to the container

  useEffect(() => {
      const renderCanvas = () => {
          const containerRect = containerRef.current.getBoundingClientRect();

          connections.forEach((connection, index) => {
              const { start, end } = connection;

              // Get references to the start and end dots
              const startDot = document.getElementById(`dot-${start}`);
              const endDot = document.getElementById(`dot-${end}`);
              const lineElement = document.getElementById(`line-${index}`);

              if (startDot && endDot && lineElement) {
                  // Calculate the dots' positions relative to the container
                  const startDotRect = startDot.getBoundingClientRect();
                  const endDotRect = endDot.getBoundingClientRect();

                  const x1 =
                      startDotRect.left - containerRect.left + startDotRect.width / 2;
                  const y1 = startDotRect.top - containerRect.top + startDotRect.height / 2;
                  const x2 = endDotRect.left - containerRect.left + endDotRect.width / 2;
                  const y2 = endDotRect.top - containerRect.top + endDotRect.height / 2;

                  // Calculate the length and angle of the line
                  const length = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
                  const angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);

                  // Position and style the line
                  lineElement.style.width = `${length}px`;
                  lineElement.style.transform = `rotate(${angle}deg)`;
                  lineElement.style.top = `${y1}px`;
                  lineElement.style.left = `${x1}px`;
              }
          });
      }
      renderCanvas()
      window.addEventListener("resize", renderCanvas);
      return () => {
          window.removeEventListener("resize", renderCanvas);
      };
  }, [dots, connections]);



  return (
      <div
          ref={containerRef}
          className="ML_container"
      >
          {/* Render all dots */}
          {dots.map((dot, index) => (
              <div
                  id={`dot-${index}`}
                  key={`dot-${index}`}
                  className={`ML_dot ${dot.hidden ? "hidden" : ""} ${dot.enabled ? "enabled" : ""} ${dot.disabled ? "disabled" : ""}`}
                  style={{
                      top: `${dot.y}%`, // Calculate position as a percentage
                      left: `${dot.x}%`, // Calculate position as a percentage
                  }}
                  // onClick={() => console.log(`Dot ${index - (Math.ceil(index/5))} clicked`)}
                  onClick={() => {
                      if (window.confirm("Are you sure you want to overwrite this reader?")) {
                          overWriteFunction(index - (Math.ceil(index/5)), null);
                      }
                  }}
              >
                  <p>{dot.t}</p>
              </div>
          ))}

        {/* Render all lines */}
        {connections.map((connection, index) => (
            <div
                id={`line-${index}`}
                key={`line-${index}`}
                className={`ML_line ${connection.solved ? "solved" : ""} ${connection.active ? "active" : ""}`}
            />
        ))}
      </div>
  );
};

export default ResponsiveMultiLineConnector;